import { Events, UnityBridge } from "@Context/common/general/context";
import { useEffect } from "react";

const AudioService = () => {

    const onPlaySound = ({src, volume}: {src: string, volume?: number} ) => {

        console.log("Playing sound", src);

        // new Howl({
        //     src: src,
        //     autoplay: true,
        //     volume: volume || 0.5,
        // }).play();

        UnityBridge.dispatchWebEvent({
            type: "PlaySound", 
            payload: {
                src: src,
                volume: volume || 1
            }
        });
    };

    useEffect(() => {
        Events.audio.playSound.uniq(onPlaySound);

        console.log("Audio service initialized");

        return () => {
            Events.audio.playSound.remove(onPlaySound);
        }
    }, []);

    return (<div id="AUDIO-SERVICE"></div>);
}

export default AudioService;